module.exports = __webpack_public_path__ + "static/media/GN.6bab8b1e.svg";